import { canStudyWrongAnswersSession } from "seneca-common/features/premium-trials/state";
import { premiumHasAccessToWrongAnswersMode } from "seneca-common/features/subscriptions/features/subscription/selectors";

export function userHasAccessToWrongAnswersMode(state: any) {
  const subscriptionGrantsAccess = premiumHasAccessToWrongAnswersMode(state);
  const trialGrantsAccess = canStudyWrongAnswersSession(state);
  return subscriptionGrantsAccess || trialGrantsAccess;
}

export function userHasAccessToWrongAnswersModeThroughTrialOnly(state: any) {
  const subscriptionGrantsAccess = premiumHasAccessToWrongAnswersMode(state);
  const trialGrantsAccess = canStudyWrongAnswersSession(state);
  return trialGrantsAccess && !subscriptionGrantsAccess;
}
